var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinterest = function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pinterest_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.967 19.711c5.378 0 9.74-4.36 9.74-9.739 0-5.377-4.362-9.739-9.74-9.739C4.59.233.23 4.595.23 9.973a9.743 9.743 0 0 0 6.045 9.013c-.3-2.324.239-4.24.763-6.104.193-.684.384-1.361.53-2.049-.945-1.516.116-4.577 2.11-3.822 1.177.444.739 1.758.3 3.07-.476 1.429-.953 2.857.65 3.163 3.212.617 4.523-5.31 2.534-7.238-2.883-2.778-8.378-.062-7.7 3.916.084.495.895 1.272.895 1.272s-.04.473-.25 1.345C4.26 12.15 3.489 10.767 3.56 8.922 3.672 5.9 6.406 3.79 9.151 3.494c3.466-.372 6.721 1.212 7.177 4.323.506 3.51-1.567 7.31-5.278 7.038-.753-.054-1.18-.335-1.677-.665-.167-.11-.342-.226-.54-.34-.418 2.091-.924 4.1-2.372 5.21 1.088.42 2.27.651 3.506.651Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pinterest_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPinterest;